// extracted by mini-css-extract-plugin
module.exports = {"varSpDown2":"0.5rem","varSpUp4":"2rem","header":"header--f6868","urlWrapper":"urlWrapper--ddb50","url":"url--12bfb","copyLink":"copyLink--c5b47","editButton":"editButton--c34d8"};